import * as AppConstants from 'app/AppConstants';

const initialState = () => ({
  teamByUserId: {},
});

export default (state = initialState(), action) => {
  switch (action.type) {
    case AppConstants.PEOPLE__LOADED_TEAM: {
      const {userId, reports, reportsTo, peers} = action.payload;
      return {
        ...state,
        teamByUserId: {
          ...state.teamByUserId,
          [userId]: {reports, reportsTo, peers},
        },
      };
    }
    default:
      return state;
  }
};
